import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Routes from './Routes';
import { ConfigProvider } from './contexts/ConfigContext';
import { UserProvider } from './contexts/UserContext';
import { CompanyProvider } from './contexts/CompanyContext';
import reportWebVitals from './reportWebVitals';

import { ContactProvider } from './contexts/ContactContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider>
        <UserProvider>
            <CompanyProvider>
                <ContactProvider>
                    <Routes />
                </ContactProvider>
            </CompanyProvider>
        </UserProvider>
    </ConfigProvider>
  </React.StrictMode>
);

reportWebVitals();
